module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aboutus-content"
  }, [_c('banner', {
    attrs: {
      "url": "aboutus",
      "hasDivider": "",
      "clazz": "aboutus-banner"
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "aboutus-section1"
  }, [_c('el-tabs', {
    staticClass: "aboutus-tab",
    attrs: {
      "type": "border-card"
    }
  }, [_c('el-tab-pane', [_c('h1', {
    staticClass: "aboutus-tabpane",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("公司介绍")]), _vm._v(" "), _c('div', {
    staticClass: "section1-tab1 tc"
  }, [_c('div', {
    staticClass: "tab1-area1"
  }, [_c('img', {
    staticClass: "area1-img",
    attrs: {
      "src": require("../../assets/img/aboutUs/tab1-area1-1.png"),
      "alt": "我们能为您提供什么价值？"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "area1-content dib tl"
  }, [_c('h1', {
    staticClass: "content-title"
  }, [_vm._v("我们能为您提供什么价值？")]), _vm._v(" "), _c('span', {
    staticClass: "left-comma"
  }, [_vm._v("“")]), _vm._v(" "), _c('div', {
    staticClass: "content-main dib"
  }, [_vm._v("\n                在全球范围内，甄云提供一站式采购数字化管理平台，为您提供采购管理解决方案，帮您重构采购业务流程，从而有效提升供应效率，降低风险，成本。\n                "), _c('br'), _vm._v("\n                迄今为止，甄云已陆续服务中车，碧桂园集团、新希望集团、光明乳业、潍柴动力、TCL、东方电气、普洛斯、天合光能、石药集团、隆基股份、腾讯旗下公司等600+家国内外知名大中型企业，丰富的实施经验，为您提供可行的采购管理解决方案。\n              ")]), _vm._v(" "), _c('span', {
    staticClass: "right-comma"
  }, [_vm._v("”")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab1-area2"
  }, [_c('h1', {
    staticClass: "area2-title"
  }, [_vm._v("一个平台，一份承诺，推动企业采购变革")]), _vm._v(" "), _c('div', {
    staticClass: "area2-divider dib"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-line"
  }, [_c('div', {
    staticClass: "line-misc dib first tl"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("01")]), _vm._v(" "), _c('h2', {
    staticClass: "title"
  }, [_vm._v("全球采购管理视野和先进技术的结合")]), _vm._v(" "), _c('p', {
    staticClass: "misc"
  }, [_vm._v("\n                  每个公司和部门都有其特色，我们的采购系统涵盖独立部署和云平台及定制开发，根据您公司不同需求，按需而做，实现不同部门之间更好地协作，降低成本，实时可见。采用全球先进开发技术，并遵循不同行业特点，为企业提供实践方案。\n                ")])]), _vm._v(" "), _c('img', {
    staticClass: "line-image",
    attrs: {
      "src": require("../../assets/img/aboutUs/tab1-line-first.png"),
      "alt": "全球采购管理视野和先进技术的结合"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-line"
  }, [_c('img', {
    staticClass: "line-image",
    attrs: {
      "src": require("../../assets/img/aboutUs/tab1-line-second.png"),
      "alt": "一个工具，满足您的所有需求"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line-misc dib second tl"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("02")]), _vm._v(" "), _c('h1', {
    staticClass: "title"
  }, [_vm._v("一个工具，满足您采购全流程管理")]), _vm._v(" "), _c('div', {
    staticClass: "misc"
  }, [_c('p', [_vm._v("共赢生态：融合核心企业，上游供应商，云平台资源，构建您采购所需生态圈")]), _vm._v(" "), _c('p', [_vm._v("互联信息：覆盖企业内部采购供应信息，打通企业与供应商的信息流商流，物流，资金流")]), _vm._v(" "), _c('p', [_vm._v("采购流程闭环管理：从采购需求，供应商管理到付款结算过程全周期管理，系统无缝覆盖全采购业务流程。")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab1-area3"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("甄云SRM供应链管理系统")]), _vm._v(" "), _c('h2', {
    staticClass: "subtitle"
  }, [_vm._v("一站式提升采购供应管理效率，实现增效降本")]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('el-button', {
    staticClass: "area3-button demo",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goRegister('guanyuwomen-guanli-tiyan')
      }
    }
  }, [_vm._v("申请体验")]), _vm._v(" "), _c('el-button', {
    staticClass: "area3-button consult",
    attrs: {
      "round": ""
    },
    on: {
      "click": _vm.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "tab1-area4"
  }, [_c('h1', {
    staticClass: "area4-title"
  }, [_vm._v("为什么选择我们")]), _vm._v(" "), _c('div', {
    staticClass: "area4-divider dib"
  }), _vm._v(" "), _c('div', {
    staticClass: "area4-main"
  }, [_c('div', {
    staticClass: "content-box first dib"
  }, [_c('img', {
    staticClass: "box-icon",
    attrs: {
      "src": require("../../assets/img/aboutUs/1_iocn.png"),
      "alt": "我们的发展"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "box-title"
  }, [_vm._v("我们的发展")]), _vm._v(" "), _c('p', {
    staticClass: "box-content tl"
  }, [_vm._v("\n                  甄云SRM自2005年开始产品研发，迄今为止已进行四次大版本升级迭代，我们不断创新和优化我们的解决方案，结合大数据以及其他生态合作伙伴来更好的服务企业，为企业采购管理赋能。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-box second dib"
  }, [_c('img', {
    staticClass: "box-icon",
    attrs: {
      "src": require("../../assets/img/aboutUs/2_iocn.png"),
      "alt": "专家随时为您服务"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "box-title"
  }, [_vm._v("专家随时为您服务")]), _vm._v(" "), _c('p', {
    staticClass: "box-content tl"
  }, [_vm._v("\n                  公司60%以上为产品研发人员。销售及交付团队大多来自全球知名管理软件厂商、各大互联网公司和咨询公司，建立通畅的服务沟通网络年允许故障小于0.4小时，为客户提供优质咨询和解决方案。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "content-box third dib"
  }, [_c('img', {
    staticClass: "box-icon",
    attrs: {
      "src": require("../../assets/img/aboutUs/3_iocn.png"),
      "alt": "为客户创造和提升利润"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "box-title"
  }, [_vm._v("为客户创造和提升利润")]), _vm._v(" "), _c('p', {
    staticClass: "box-content tl"
  }, [_vm._v("\n                  我们将致力于了解、预期并超越客户的期望和需求，通过在技术、方法、人力资源的提升，赢得并维持客户的忠诚度我们将通过服务的提供和延伸实施，帮助客户不断发展并使其得到快速、高效的经济回报。\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "tab1-area5"
  }, [_c('h1', {
    staticClass: "area5-title"
  }, [_vm._v("企业简介")]), _vm._v(" "), _c('div', {
    staticClass: "area5-divider dib"
  }), _vm._v(" "), _c('div', {
    staticClass: "area5-main"
  }, [_c('div', [_vm._v("企业名称:\t上海甄云信息科技有限公司")]), _vm._v(" "), _c('div', [_vm._v("官网：www.going-link.com")]), _vm._v(" "), _c('div', [_vm._v("企业简介："), _c('br'), _vm._v("上海甄云信息科技有限公司是国内采购数字化管理平台提供商，成立于2017年6月，致力于企业数字化采购变革，为中大型企业提供企业生产性及非生产性物资采购数字化解决方案，推动企业采购更加智能、高效、透明、降本，赋能企业经营发展降本提效。\n                公司总部位于上海，从2005年就推出SaaS采购数字化产品，专注采购数字化升级，从用户真实应用场景出发，解决企业采购管理应用实际痛点。目前，甄云科技产品已陆续服务全球30多个行业，提供行业解决方案。\n              ")]), _vm._v(" "), _c('div', [_vm._v("企业产品服务："), _c('br'), _vm._v("甄云SRM，为企业的采购与交易提供一体化的智能管理平台与解决方案。")]), _vm._v(" "), _c('div', [_vm._v("企业发展历程："), _c('br'), _vm._v("\n                2017年6月：上海甄云信息科技有限公司正式成立，甄云SRM基于云平台为企业供应链提供数字化管理、数字化服务。"), _c('br'), _vm._v("\n                2018年11月：甄云科技获得A股上市公司汉得信息、京东和众麟资本1.5亿元的A轮融资。"), _c('br'), _vm._v("\n                2019年12月：甄云数字化采购平台正式发布并全面推广，定位于中大型企业公有云业务。"), _c('br'), _vm._v("\n                2020年4月：甄云科技发布云战略，全面升级采购云服务能力。"), _c('br'), _vm._v("\n                2020年11月： 甄云科技完成B轮融资，总额达3亿元，由蓝湖资本领投，德同资本、红点创投中国基金、钟鼎资本及众麟资本等机构资本跟投。")]), _vm._v(" "), _c('div', [_vm._v("企业文化理念："), _c('br'), _vm._v("链接企业采购未来")]), _vm._v(" "), _c('div', [_vm._v("企业地址："), _c('br'), _vm._v("公司地址：上海市青浦区嘉松中路5888号A座10F")]), _vm._v(" "), _c('div', [_vm._v("企业荣誉："), _c('br'), _vm._v("\n                1、甄云科技入选上海市经济和信息化委员会发布“2020上海软件和信息技术服务业高成长百家”"), _c('br'), _vm._v("\n                链接见政府网站公示名单：http://www.sheitc.sh.gov.cn/xxfw/20210104/e09cf319e8734ee89ef9e3b17a181a44.html"), _c('br'), _vm._v("\n                2、甄云科技荣获中国软件和信息服务年度数字化采购管理领域领军企业"), _c('br'), _vm._v("\n                发布链接：https://baijiahao.baidu.com/s?id=1690545276834675694&wfr=spider&for=pc"), _c('br'), _vm._v("\n                3、甄云科技入选亿欧智库发布2020全球企业服务科技创新TOP50"), _c('br'), _vm._v("\n                发布链接：https://www.iyiou.com/analysis/202012111012177"), _c('br'), _vm._v("\n                4、甄云科技入选2020爱分析中国采购数字化厂商榜单"), _c('br'), _vm._v("\n                发布链接：https://wenku.baidu.com/view/baa67b6f3b68011ca300a6c30c2259010202f3a5.html\n              ")])])])])]), _vm._v(" "), _c('el-tab-pane', [_c('h1', {
    staticClass: "aboutus-tabpane",
    attrs: {
      "slot": "label"
    },
    slot: "label"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "section1-tab2 tc"
  }, [_c('h2', {
    staticClass: "tab2-title"
  }, [_vm._v("联系我们")]), _vm._v(" "), _c('div', {
    staticClass: "tab2-divider dib"
  }), _vm._v(" "), _c('div', {
    staticClass: "tab2-content"
  }, [_c('img', {
    staticClass: "content-map",
    attrs: {
      "src": require("../../assets/img/aboutUs/tab2-map.png"),
      "alt": "联系我们"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "content-marker",
    attrs: {
      "src": require("../../assets/img/aboutUs/tab2-marker.png"),
      "alt": "联系我们"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-inputer dib"
  }, [_c('div', {
    staticClass: "info"
  }, [_c('el-input', {
    staticClass: "info-input dib",
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.name),
      callback: function($$v) {
        _vm.name = $$v
      },
      expression: "name"
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "info-input dib",
    attrs: {
      "maxlength": 11,
      "placeholder": "电话"
    },
    model: {
      value: (_vm.telephone),
      callback: function($$v) {
        _vm.telephone = $$v
      },
      expression: "telephone"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "textarea-container"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "textarea-inner",
    attrs: {
      "rows": "5",
      "cols": "30",
      "placeholder": "留言信息..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "focus": function($event) {
        return _vm.borderFocus()
      },
      "blur": function($event) {
        return _vm.borderBlur()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('el-input', {
    staticClass: "validate-input",
    attrs: {
      "maxlength": 4,
      "placeholder": "请输入验证码"
    },
    model: {
      value: (_vm.validate),
      callback: function($$v) {
        _vm.validate = $$v
      },
      expression: "validate"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "validate-img",
    attrs: {
      "src": _vm.validateUrl,
      "alt": "请求失败,请检查网络"
    },
    on: {
      "click": _vm.changeCode,
      "mousedown": _vm.disableDrag
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "submit-button",
    attrs: {
      "id": "submit"
    },
    on: {
      "click": _vm.leaveMessage
    }
  }, [_vm._v("请您留言")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "content-info first tl"
  }, [_c('div', {
    staticClass: "pre-sales dib"
  }, [_vm._v("售前热线："), _c('span', {
    staticClass: "phone"
  }, [_vm._v("400-116-0808")])]), _vm._v(" "), _c('div', {
    staticClass: "address dib"
  }, [_vm._v("公司地址：上海青浦区嘉松中路5888号")])]), _vm._v(" "), _c('div', {
    staticClass: "content-info tl"
  }, [_c('div', {
    staticClass: "service dib"
  }, [_vm._v("服务热线："), _c('span', {
    staticClass: "phone"
  }, [_vm._v("400-116-0808")])]), _vm._v(" "), _c('div', {
    staticClass: "email dib"
  }, [_vm._v("联系邮箱："), _c('span', {
    staticClass: "email"
  }, [_vm._v("marketing@going-link.com")])])])])])])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40343971"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/aboutUs/aboutUs.vue
// module id = 639
// module chunks = 12